


const h37_endpoint = "https://grch37.rest.ensembl.org/lookup/symbol/homo_sapiens";
const h38_endpoint= "https://rest.ensembl.org/lookup/symbol/homo_sapiens";


export {h37_endpoint,h38_endpoint}